import React from 'react';
var ProgressBar = function ProgressBar(_ref) {
  var data = _ref.data,
    currentIndex = _ref.currentIndex,
    setcurrentIndex = _ref.setcurrentIndex;
  return /*#__PURE__*/React.createElement("div", {
    className: "oticon-more-progress-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "oticon-more-progress-bar__filled-color",
    style: {
      height: currentIndex / data.length * 100 + 'vh'
    }
  }), data.map(function (part) {
    return /*#__PURE__*/React.createElement("div", {
      className: "oticon-more-progress-bar__part ".concat(part.indexCounter <= currentIndex ? 'active' : ''),
      style: {
        height: "calc(100vh / ".concat(data.length, ")")
      },
      onClick: function onClick() {
        return setcurrentIndex(part.indexCounter);
      }
    });
  }));
};
export default ProgressBar;